import { b as e, _ as t } from "./before-send-e0bf189c.js";
import { init as n, configureScope as i, captureException as o, Severity as r, createReduxEnhancer as a } from "@sentry/react";
export * from "@sentry/react";
var s = {
  beforeSend: e,
  denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i, /analytics\.tiktok\.com/, /ad\.doubleclick\.net/, /clarity\.ms/, /www\.googletagmanager\.com/, /tagmanager\.google\.com/, /maps\.googleapis\.com/, /static\.ads-twitter\.com/, /C:\//],
  ignoreErrors: [/instantSearchSDKJSBridgeClearHighlight/, /ibFindAllVideos/, /ibPauseAllVideos/, /fbq is not defined/, /UET is not defined/, /translate_fp is not defined/, /ttq is not defined/, /tgetT is not defined/, /AFMA_ReceiveMessage/, /null is not an object \(evaluating 'fr.start'\)/, /twttr is not defined/, /window.tubemate/]
};
function d(e) {
  n(t(t({}, s), e)), i(function (e) {
    e.setTag("runtime", "browser");
  });
}
function c() {
  for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
  var i = e[0],
    a = e[1];
  return o(i, t(t({}, a), {
    level: r.Fatal
  }));
}
var l = a;
export { c as captureFatalException, l as createReduxEnhancer, d as init, s as initOptions };